import React from "react";
import Disclaimer from "../../shared/footer/disclaimer";

const ExtraPhotos = (props) => {
  let listing = props.listing;

  let printImages = listing.images
    .filter((images) => images.orientation !== "portrait")
    .slice(props.imageLimit, props.imageLimit + 9)
    .map((image, index) => {
      return (
        <div className={`ad-${index + 1} fit-image`} key={index}>
          <img alt={`listing view ${index + 1}`} src={image.src} />
        </div>
      );
    });

  let agents = () => {
    let agentLength = listing.agents.length;

    let agent = listing.agents.slice(0, 4).map((f, i) => {
      if (agentLength === 1 || (agentLength === 2 && i === 0)) {
        return (
          <li className="agentbold" key={i}>
            {f.name}
          </li>
        );
      } else if (agentLength === i + 1) {
        return <li className="agentbold" key={i}>{`and ${f.name}`}</li>;
      } else {
        return <li className="agentbold" key={i}>{`${f.name},`}</li>;
      }
    });

    return <ul>{agent}</ul>;
  };

  const url = () => {
    if (
      listing.status &&
      ["rented", "sold"].includes(listing.status.toLowerCase())
    ) {
      return `sothebysrealty.com/eng/sold/detail/180-l-85298-${listing.listingNumber}`.toUpperCase();
    }
    return listing.rfgid
      ? `SOTHEBYSREALTY.COM/id/` + listing.rfgid.toUpperCase()
      : listing.mls
      ? `SOTHEBYSREALTY.COM/id/` + listing.mls.toUpperCase()
      : "";
  };

  return (
    <div id="print-extraphotos" className="page-break">
      <div className="extraimg-header">
        <div className="print-vanity-website">
          {listing.vanityDomain ? listing.vanityDomain.toUpperCase() : url()}
          <div className="print-view-spacer">
            <hr className="left"></hr>
          </div>
        </div>
        <div className="addphotos-agents">
          <div className="presented-by">PRESENTED BY:</div>
          {agents()}
        </div>
      </div>
      <div className="extraphotos">{printImages}</div>
      <div className="extraimg-footer">
        <div className="extraimg-disclaimer">
          <Disclaimer />
        </div>
      </div>
    </div>
  );
};

export default ExtraPhotos;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/extraphotos.js